import { getAccessTokenData } from "./get-access-token-data";

const isAccessTokenValid = (clockSkewToleranceSeconds: number = 60) => {
  try {
    const accessToken = getAccessTokenData();

    if (!accessToken) {
      return false;
    }

    if (!accessToken.exp) {
      return false;
    }

    const currentTime = Math.floor(Date.now() / 1000);

    return accessToken.exp > currentTime - clockSkewToleranceSeconds;
  } catch {
    return false;
  }
};

export default isAccessTokenValid;
